<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  font-size: 16px;
  height: 100%;
  font-family: "微软雅黑", serif;
}

* {
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}
*::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

</style>



// WEBPACK FOOTER //
// src/App.vue